<template>
  <!-- 底部  -->
  <div id="footer" class="container-fluid">    
    <div class="row serves">
      <div class="col-xs-6 col-sm-6 col-md-3 col-lg-3" v-for="(item,index) in footerList" :key="index">
        <div class="serves-item"><div :class="item.icon"></div><span>{{item.title}}</span></div>
      </div>
    </div>
    <!-- 电脑版 -->
    <div class="row footer-about hidden-sm hidden-xs" >
      <ul class="col-xs-6 col-sm-6 col-md-2 col-lg-2">
        <li @click="toProducts"><h4>采寻产品</h4></li>
        <li @click="toProducts">-数据采集产品</li>
        <li @click="toProducts">-智能集成产品</li>
        <li @click="toProducts">-自动控制产品</li>
        <li @click="toProducts">-手持穿戴产品</li>
        <li @click="toProducts">-其他</li>
      </ul>
      <ul class="col-xs-6 col-sm-6 col-md-2 col-lg-2">
        <li @click="toExample"><h4>行业案例</h4></li>
        <li @click="toExample">-余杭百世</li>
        <li @click="toExample">-杭州中外运</li>
        <li @click="toExample">-上海奉贤中通</li>
        <li @click="toExample">-8090服饰</li>
      </ul>
      <ul class="col-xs-6 col-sm-6 col-md-2 col-lg-2">
        <li @click="toAboutUs"><h4>关于采寻</h4></li>
        <li @click="toAboutUs">-公司介绍</li>
        <li @click="toContactUs">-联系我们</li>
      </ul>
      <ul class="col-xs-6 col-sm-6 col-md-4 col-lg-4 border-left">
        <li class="nocursor"<h4>400-150-1007</h4></li>
        <li class="nocursor">周一至周五 9：00-18：00</li>
        <li class="nocursor">Copyright © 采寻网络科技（杭州）有限公司</li>
        <li class="icp"><a href="http://beian.miit.gov.cn" target="_blank">浙ICP备19026824号</a></li>
        <li class="public">
          <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33010802010846" target="_blank">
            <img src="../assets/img/ICP.png" />
            <p>浙公网安备 33010802010846号</p >
          </a>
        </li>
        <li>
          <a href="https://xyt.xcc.cn/getpcInfo?sn=1798671483463987200&language=CN&certType=8&url=www.joyfinder.com.cn" target="_blank" style="position: relative;display: inline-block;height: 38px;">
          <div style="width:100%;height:100%;position: absolute;top: 0;left: 0;"></div><embed src="https://program.xinchacha.com/web/1798671483463987200=www.joyfinder.com.cn.svg" width="103" height="38" type="image/svg+xml" pluginspage="//www.adobe.com/svg/viewer/install/"/></a> 
        </li>
      </ul>
      <ul>
        <li><img src="../assets/img/weixin.png" style="height:134px" alt="采寻网络科技"></li>
      </ul>
    </div>
    <!-- 手机版 -->
    <div class="row visible-xs visible-sm">
      <ul>
        <li class="menu">
          <div class="menu-up" @click="handlemenu">
            <span>采寻产品</span>
            <i :class="glyphicon"></i>
          </div>
          <ul class="menu-down" v-show="menuShow">
            <li @click="toProducts">-数据采集产品</li>
            <li @click="toProducts">-智能集成产品</li>
            <li @click="toProducts">-自动控制产品</li>
            <li @click="toProducts">-手持穿戴产品</li>
            <li @click="toProducts">-其他</li>
          </ul>
        </li>
        <li @click="toExample">行业案例</li>
        <li @click="toJoinUs">加入我们</li>
        <li @click="toAboutUs">关于采寻</li>
        <li @click="toContactUs">联系我们：<strong>400-150-1007</strong></li>
      </ul>
      <div class="pubilc-info">
        <p>Copyright © 采寻网络科技（杭州）有限公司</p>
        <a href="http://beian.miit.gov.cn" target="_blank">浙ICP备19026824号</a>
        <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33010802010846" target="_blank">
          <img src="../assets/img/ICP.png"/> 浙公网安备 33010802010846号 </a>
      </div>
      <div>
        <a href="https://xyt.xcc.cn/getpcInfo?sn=1798671483463987200&language=CN&certType=8&url=www.joyfinder.com.cn" target="_blank" style="position: relative;display: inline-block;height: 38px;">
        <div style="width:100%;height:100%;position: absolute;top: 0;left: 0;"></div><embed src="https://program.xinchacha.com/web/1798671483463987200=www.joyfinder.com.cn.svg" width="103" height="38" type="image/svg+xml" pluginspage="//www.adobe.com/svg/viewer/install/"/></a> 
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Bottom',
  
  data(){
    return{
      menuShow: false,
      glyphicon:"glyphicon glyphicon-menu-down",
      footerList:[
        {
          icon:"wrench icon",
          title:"上门维修服务",
        },
        {
          icon:"earphone icon",
          title:"专属客服答疑",
        },
        {
          icon:"time icon",
          title:"一年免费质保",
        },
        {
          icon:"leaf icon",
          title:"售后体系完善",
        }
      ]
    }
  },
  methods:{
    handlemenu(){
      this.menuShow = !this.menuShow
      if(this.menuShow){
        this.glyphicon = "glyphicon glyphicon-menu-up"
      }else{
        this.glyphicon = "glyphicon glyphicon-menu-down"
      }
    },
    toAboutUs(){
      this.$router.push({name:"AboutUs"})
    },
    toContactUs(){
      this.$router.push({name:"ContactUs"})
    },
    toExample(){
      this.$router.push({name:"CustomesExample"})
    },
    toProducts(){
        this.$router.push({name:"ProductCenter"})
    },
    toJoinUs(){
      this.$router.push({name:"JoinUs"})
    }
  }
}
</script>
<style lang="less" scoped>
#footer{
  width: 100%;
  height: 100%;
  background-color: #272727;
  overflow: hidden;
  text-align: center;
  padding: 8% 10%;
  color: #fff;
  .serves{
    border-bottom: 1px solid #CFCFCF;
    padding: 0 0 40px 0;
    margin-bottom: 30px;
    .serves-item{
      font-size: 20px;
      .icon{
        vertical-align: middle;
        margin-right: 10px;
        display: inline-block;
        width: 40px;
        height: 40px;
        background-color: red;
      }
      .wrench{
        background: url(../assets/img/icon_pc.png) -0px -208px;
      }
      .earphone{
        background: url(../assets/img/icon_pc.png) -40px -208px;
      }
      .time{
        background: url(../assets/img/icon_pc.png) -80px -208px;
      }
      .leaf{
        background: url(../assets/img/icon_pc.png) -120px -208px;
      }
    }
  }
  
  .footer-about{
    ul{
      display: inline;
      text-align: left;
      li{
        line-height: 30px;
        cursor: pointer;
        h4{
          font-weight: bold;
          font-size: 16px;
        }
      }
      /* ICP备案 */
      li.icp a{
        text-decoration: none;
        // color: #939393
        color: #fff;
      }
      /* 公网备案 */
      li.public{
        a{
          text-decoration: none;
          line-height: 20px;
        }
        p:hover{
          color: #939393;
        }
        img{
          display: inline-block;
          vertical-align: sub;
        }
        p{
          display: inline-block;
          line-height: 20px;
          margin-left: 5px;
          color: #fff;
        }
      }
      li a:hover{
        color: #939393;
      }
      li.nocursor{
        cursor: default;
      }
      
    }
    .border-left{
      border-left: 1px solid #CFCFCF;
      padding-left: 3%;
    }
  }
}
/* 手机 */
@media screen and (max-width: 768px){
  #footer{
    background-color: #F5F5F7;
    color: #272727;
    .serves{
      margin-bottom: 0px;
      .serves-item{
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-bottom: 20px;
        .icon{
          margin-right: 0;
          width: 30px;
          height: 30px;
          margin-bottom: 10px;
        }
        .wrench{
        background: url(../assets/img/foot_icon.png) 0px 0px no-repeat;
        }
        .earphone{
          background: url(../assets/img/foot_icon.png) -30px 0px no-repeat;
        }
        .time{
          background: url(../assets/img/foot_icon.png) -60px 0px no-repeat;
        }
        .leaf{
          background: url(../assets/img/foot_icon.png) -90px 0px no-repeat;
        }
        span{
          font-size: 16px;
        }

      }
    }
    // 底部菜单
    ul {
      li{
        text-align: left;
        line-height: 45px;
        border-bottom: 1px solid #CFCFCF;
      }
      // 父级菜单
      li.menu{
        position: relative;
        .menu-up{
          display: flex;
          justify-content: space-between;
          i{
            line-height: 45px;
           
          } 
        }
        // 子级菜单
        ul{
          margin-left: 30px;
          margin-bottom: 15px;
          li{
            line-height: 30px;
            border: none;
            
          }
        }
      }
    }
        /* 底部联系方式 */
    h5{
      line-height: 30px;
      font-size: 15px;
    }
    .pubilc-info{
      padding-top: 20px;
      // text-align: left;
      p{
        line-height: 24px;
        color: #666;
      }
      a{
        display: inline-block;
        line-height: 24px;
        img{
          display: inline-block;
          vertical-align: top;
          display: inline-block;  
        }
      }
    }
  }
}
/* 平板 */
@media screen and (min-width: 768px) and (max-width: 992px){
  #footer{
    background-color: #F5F5F7;
    color: #272727;
    .serves{
      margin-bottom: 0px;
      .serves-item{
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-bottom: 20px;
        .icon{
          margin-right: 0;
          width: 30px;
          height: 30px;
          margin-bottom: 10px;
        }
        .wrench{
        background: url(../assets/img/foot_icon.png) 0px 0px no-repeat;
        }
        .earphone{
          background: url(../assets/img/foot_icon.png) -30px 0px no-repeat;
        }
        .time{
          background: url(../assets/img/foot_icon.png) -60px 0px no-repeat;
        }
        .leaf{
          background: url(../assets/img/foot_icon.png) -90px 0px no-repeat;
        }
        span{
          font-size: 16px;
        }
      }
    }
    // 底部菜单
    ul {
      li{
        text-align: left;
        line-height: 45px;
        border-bottom: 1px solid #CFCFCF;
      }
      // 父级菜单
      li.menu{
        position: relative;
        .menu-up{
          display: flex;
          justify-content: space-between;
          i{
            line-height: 45px;
            
          } 
        }
        // 子级菜单
        ul{
          margin-left: 30px;
          margin-bottom: 15px;
          li{
            line-height: 30px;
            border: none;
          }
        }
      }
    }
    /* 底部联系方式 */
    h5{
      line-height: 30px;
      font-size: 15px;
    }
    img {
      display: inline-block;
    }
  }
}
</style>
